import { useContext } from 'react'

import { CallStatusContext } from '../../providers'

export function useCallStatus() {
  const { status, setStatus } = useContext(CallStatusContext)
  return { status, setStatus }
}
